<template>
    <footer class="px-4 mx-2">
        <div class="row align-items-center justify-content-lg-between">
            <div class="col-lg-6">
                <div class="copyright text-center text-lg-left text-muted">
                    © {{ year }}
                    <a
                        href="https://www.talus.ch"
                        class="font-weight-bold ml-1"
                        target="_blank"
                    >Talus Informatik AG</a>
                </div>
            </div>
            <div class="col-lg-6">
                <ul class="nav nav-footer justify-content-center justify-content-lg-end">
                    <li class="nav-item">
                        <a href="#!" class="nav-link" @click.prevent="$router.push('/dashboard')">myTalus</a>
                    </li>
                    <li class="nav-item">
                        <a
                            href="https://www.talus.ch/de/support/"
                            class="nav-link"
                            target="_blank"
                            >Talus Support</a>
                    </li>
                    <li class="nav-item">
                        <a href="#!" class="nav-link" @click.prevent="$router.push('/data-protection')">Datenschutz</a>
                    </li>
                    <li class="nav-item">
                        <a href="/docs/Nutzungsbedingungen_Kundenportal.pdf" class="nav-link" target="_blank">Nutzungsbedingungen</a>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    data() {
        return {
            year: new Date().getFullYear(),
        };
    },
};
</script>
<style></style>
